<script setup lang="ts">
/**
 * The top of a screen: the status-bar safe area, then a 56px bar with the
 * page's `<h1>` in Title/Large. The `leading` slot holds back navigation,
 * `trailing` the page's action — both `UiIconButton`s. Without a title and
 * slots it still reserves the safe area, so content never slides under the
 * status bar. It scrolls with the page, on the canvas and its glow, as v1's
 * screens did. `UiAppPage` renders one; use it directly only inside
 * `UiScreen`'s `header` slot.
 * Figma: OMB Kit › App Header.
 */
const props = defineProps<{
  title?: string;
}>();

defineSlots<{
  leading?: () => unknown;
  trailing?: () => unknown;
}>();
</script>

<template>
  <header class="relative z-10 pt-safe-top">
    <div class="flex min-h-14 items-center gap-2 px-4 py-2">
      <slot name="leading" />
      <h1
        v-if="props.title"
        class="min-w-0 flex-1 truncate text-title-lg font-semibold"
        :class="{ 'ps-2': !$slots.leading }"
        data-testid="ui-app-header-title"
      >
        {{ props.title }}
      </h1>
      <div
        v-else
        class="flex-1"
      />
      <slot name="trailing" />
    </div>
  </header>
</template>
